import { render, staticRenderFns } from "./FormInputCurrency.vue?vue&type=template&id=1ba9791c&"
import script from "./FormInputCurrency.vue?vue&type=script&lang=js&"
export * from "./FormInputCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba9791c')) {
      api.createRecord('1ba9791c', component.options)
    } else {
      api.reload('1ba9791c', component.options)
    }
    module.hot.accept("./FormInputCurrency.vue?vue&type=template&id=1ba9791c&", function () {
      api.rerender('1ba9791c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputCurrency.vue"
export default component.exports